import React from 'react'
import { BodyText, Row, Col } from '@paypalcorp/pp-react'
import serverData from '../../utils/server-data'

const PrivacyOption = ({ heading, content }) => (
  <Row className="privacy-option-container">
    <div className="privacyHub-imageContainer" role="img" aria-label="Option">
      <img
        src={`https://${serverData.cdnHostName}/privacyhub/check.svg`}
        alt="check"
      />
    </div>
    <Col sm={10} xs={10} className="privacyHub-options">
      <BodyText strong>{heading}</BodyText>
      <BodyText>{content}</BodyText>
    </Col>
  </Row>
)

export default PrivacyOption
